import React, { useState, useEffect, useCallback } from 'react';
import { API_BASE_URL } from '../../config/api';

function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem('admin_token');
    return { 'Authorization': `Bearer ${token}` };
  }, []);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/audit-logs`, { headers: getAuthHeaders() });
      if (res.ok) {
        setLogs(await res.json());
      }
    } catch (e) {
      console.error('Failed to fetch audit logs', e);
    } finally {
      setLoading(false);
    }
  }, [getAuthHeaders]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  const formatDetails = (detailsStr) => {
    if (!detailsStr) return '—';
    try {
      const parsed = JSON.parse(detailsStr);
      return (
        <pre style={{ fontSize: '11px', background: '#f5f5f5', padding: '6px', borderRadius: '4px', overflowX: 'auto', maxWidth: '350px' }}>
          {JSON.stringify(parsed, null, 2)}
        </pre>
      );
    } catch (e) {
      return detailsStr;
    }
  };

  const getActionBadgeClass = (action) => {
    switch (action) {
      case 'promote': return 'badge-success';
      case 'suspend': return 'badge-danger';
      case 'adjust_reputation': return 'badge-info';
      case 'change_role': return 'badge-info';
      default: return 'badge-info';
    }
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h3>RBAC Security & Operations Audit Trail</h3>
        <button className="btn-outline" onClick={fetchLogs}>Refresh</button>
      </div>

      {loading ? (
        <p>Loading audit feed...</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Actor</th>
              <th>Domain/Entity</th>
              <th>Action</th>
              <th>Reason</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td style={{ whiteSpace: 'nowrap', fontSize: '13px' }}>
                  {new Date(log.created_at).toLocaleString()}
                </td>
                <td><strong>{log.actor_name}</strong></td>
                <td>
                  <span style={{ fontSize: '13px', fontFamily: 'monospace' }}>
                    {log.entity_name}
                  </span>
                </td>
                <td>
                  <span className={getActionBadgeClass(log.action)}>
                    {log.action?.toUpperCase()}
                  </span>
                </td>
                <td style={{ maxWidth: '200px', fontSize: '13px' }}>{log.reason || '—'}</td>
                <td>{formatDetails(log.details)}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>No audit trail records found.</td></tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AuditLogs;
